module.exports = __webpack_public_path__ + "img/0090.68b665d3.png";